<template>
  <div class="kk-design__icon" :class="icon" :data-test-id="`icon-item-${icon}`" @click="selectIcon"></div>
</template>
<script>
export default {
  props: ["icon"],
  emits: ["select-icon"],
  methods: {
    selectIcon() {
      this.$emit("select-icon", this.icon);
    },
  },
};
</script>
<style lang="less" scoped>
@import "../../../../assets/styles/variables.less";

.kk-design {
  &__icon {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 2rem;
    height: 2rem;
    font-size: 2rem;
    color: @kk-color-primary-blue;
    border-radius: 50%;
  }
}
</style>
